module.exports = __webpack_public_path__ + "fonts/Source_Sans_3-normal-400-cyrillic-ext.18432f1.woff2";